import { render } from "./synapseComponent.vue?vue&type=template&id=59803f93&lang=pug"
import script from "./synapseComponent.vue?vue&type=script&lang=js"
export * from "./synapseComponent.vue?vue&type=script&lang=js"

import "./synapseComponent.vue?vue&type=style&index=0&id=59803f93&lang=less"

import exportComponent from "/home/runner/work/argos-control-web/argos-control-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInput,QBtn,QPageSticky});
